import { Feature } from "./shared/feature/feature.service";

interface NavAttributes {
    [propName: string]: any;
}

interface NavWrapper {
    attributes: NavAttributes;
    element: string;
}

interface NavBadge {
    text: string;
    variant: string;
    class?: string;
}

interface NavLabel {
    class?: string;
    variant: string;
}

export interface NavData {
    name?: string;
    url?: string;
    icon?: string;
    badge?: NavBadge;
    title?: boolean;
    children?: NavData[];
    variant?: string;
    attributes?: NavAttributes;
    divider?: boolean;
    class?: string;
    label?: NavLabel;
    wrapper?: NavWrapper;
    authorities?: string[];
    feature?: Feature;
    unlessFeature?: Feature;
}

export const navItems: NavData[] = [
    {
        name: "Dashboard",
        url: "/dashboard",
        icon: "feather-home",
    },
    {
        name: "Clients",
        url: "/client",
        icon: "feather-users",
    },
    {
        name: "Projects",
        url: "/project",
        icon: "feather-clipboard",
        feature: Feature.PROJECTS,
    },
    // {
    //     name: 'Calendar',
    //     url: '/calendar',
    //     icon: 'feather-calendar'
    // },
    {
        name: "Tasks",
        url: "/task",
        icon: "feather-list",
        feature: Feature.PROJECTS,
    },
    {
        name: "Client Actions",
        url: "/todo",
        icon: "feather-check-square",
    },
    {
        name: "Proposals",
        url: "/proposal",
        icon: "feather-check-circle",
        feature: Feature.PROPOSALS,
    },
    {
        name: "Documents",
        url: "/document",
        icon: "feather-folder",
    },
    {
        name: "Contacts",
        url: "/contact",
        icon: "feather-phone",
    },
    {
        name: "Time Tracking",
        url: "/time-tracking",
        icon: "feather-clock",
        feature: Feature.TIME_TRACKING,
    },
    {
        name: "Billing",
        url: "/billing-dashboard",
        icon: "feather-dollar-sign",
        authorities: ["ROLE_BILLING"],
        feature: Feature.BILLING,
    },
    {
        name: "Invoicing",
        url: "/invoice",
        icon: "feather-file-text",
        authorities: ["ROLE_BILLING"],
        feature: Feature.BILLING,
    },
    // {
    //     name: "ACH Migration",
    //     url: "/ach-migration",
    //     icon: "feather-refresh-cw",
    //     authorities: ["ROLE_BILLING"],
    //     feature: Feature.BILLING,
    // },
    {
        title: true,
        name: "Sales",
        feature: Feature.LEADS,
    },
    {
        name: "Leads",
        url: "/lead",
        icon: "feather-user-plus",
        feature: Feature.LEADS,
    },
    {
        title: true,
        name: "Reports",
        authorities: [
            "ROLE_REPORTING",
            "ROLE_BILLING",
            "ROLE_RECURRING_PROJECTS",
        ],
    },
    {
        name: "View Reports",
        url: "/reporting",
        icon: "feather-briefcase",
        authorities: [
            "ROLE_REPORTING",
            "ROLE_BILLING",
            "ROLE_RECURRING_PROJECTS",
        ],
    },
    {
        title: true,
        name: "Client Portal",
        authorities: ["ROLE_MANAGE_CLIENT_PORTAL_ACCESS"],
    },
    {
        name: "Access Logs",
        url: "/access-log",
        icon: "feather-inbox",
        authorities: ["ROLE_MANAGE_CLIENT_PORTAL_ACCESS"],
        feature: Feature.CLIENT_ACCESS,
    },
    {
        name: "Access Requests",
        url: "/registration",
        icon: "feather-user-check",
        authorities: ["ROLE_MANAGE_CLIENT_PORTAL_ACCESS"],
        badge: {
            text: null,
            variant: "bg-primary",
            class: "rounded-pill bg-danger me-4 font-12",
        },
        feature: Feature.CLIENT_ACCESS_REQUESTS,
    },
    {
        title: true,
        name: "Admin",
        authorities: ["ROLE_ADMIN"],
    },
    {
        name: "Users",
        url: "/user-management",
        icon: "feather-user",
        authorities: ["ROLE_ADMIN"],
    },
    {
        name: "Audit Logs",
        url: "/audit-log",
        icon: "feather-archive",
        authorities: ["ROLE_ADMIN"],
        feature: Feature.INTERNAL_ADMIN,
    },
    {
        name: "Settings",
        url: "/system/settings",
        icon: "feather-settings",
        authorities: ["ROLE_ADMIN"],
    },
    {
        name: "Customizations",
        url: "/system/customizations",
        icon: "feather-sliders",
        authorities: ["ROLE_ADMIN"],
    },
    {
        name: "Text Customizations",
        url: "/system/text-customizations",
        icon: "feather-edit",
        authorities: ["ROLE_ADMIN"],
        feature: Feature.INTERNAL_ADMIN,
    },
    {
        name: "Integrations",
        url: "/system/integrations",
        icon: "feather-shuffle",
        authorities: ["ROLE_ADMIN"],
    },
    {
        name: "Payments",
        url: "/system/payment-config",
        icon: "feather-credit-card",
        authorities: ["ROLE_ADMIN"],
        feature: Feature.BILLING,
    },
    {
        name: "Document Export",
        url: "/system/document-export",
        icon: "feather-download",
        feature: Feature.DOCUMENT_EXPORTS,
        authorities: ["ROLE_ADMIN", "ROLE_DOCUMENT_EXPORT"],
    },
    {
        title: true,
        name: "Super User",
        authorities: ["ROLE_SUPERUSER"],
    },
    {
        name: "Manage Firms",
        url: "/firm",
        icon: "feather-lock",
        authorities: ["ROLE_SUPERUSER"],
    },
    {
        name: "Manage Variables",
        url: "/firm/variables",
        icon: "feather-lock",
        authorities: ["ROLE_SUPERUSER"],
    },
];
